import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import {
  Box,
  Checkbox,
  Dialog,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { useSelector } from "react-redux";
import { EditOutlined } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import TransferTransactionModal from "./TransferTransactionModal";

const TransferTransaction = () => {
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
   const [isCreatedStatus, setIsCreatedStatus] = useState(false);
     const [checkedIds, setCheckedIds] = useState(new Set());
   console.log(isCreatedStatus)

  useEffect(() => {
    getData();
  }, []);
const getData = async() => {
  setIsLoading(true);
  const link = masterAPI["partmovement"].link;
  await axiosPrivate
    .get(`${link}`)
    .then((res) => {
      console.log("API Data:", res.data.result);
      
      // Sort the data first
      const sortedData = res.data.result.sort((a, b) => {
        return a.code.localeCompare(b.code, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });
      
      setData(sortedData);
      
      // Create a status map
      const statusMap = {};
      sortedData.forEach(item => {
        statusMap[item.id] = item.status === "Created";
      });
      setIsCreatedStatus(statusMap);
      
      setIsLoading(false);
    })
    .catch((e) => {
      console.log(e, "partmovement");
      setIsLoading(false);
      setData([]);
      setIsCreatedStatus({});
    });
};
  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };

  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  const handleDelete = async(e, id) => {
    const enableLink = masterAPI["partmovement"].enable;
    const disableLink = masterAPI["partmovement"].disable;
    if (e.target.checked) {
     await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "enable PartsMovement");
        });
    } else {
     await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "disable PartsMovement");
        });
    }
  };
const handleStatusChange = async (status) => {
  if (checkedIds.size === 0) {
    console.log("No items selected");
    return;
  }

  setIsLoading(true);
  
  // Create payload array with id and status for each selected item
  const payload = Array.from(checkedIds).map(id => ({
    id: id,
     status: status.value,
     remarks:"Test"
  }));
const statuslink = masterAPI['partmovement'].bulkStatusUpdate
  await axiosPrivate.put(
    `${statuslink}`,
    payload  
  )
  .then((response) => {
    console.log("Status update successful:", response.data);
    getData(); // Refresh the data
    setCheckedIds(new Set()); // Clear selection
  })
  .catch((error) => {
    console.error("Error updating status:", error);
    // Optionally show error message to user
  })
  .finally(() => {
    setIsLoading(false);
  });
};

  // This handles the checkbox selection
  const handleCheckboxChange = (id) => {
    const newCheckedIds = new Set(checkedIds);
    if (newCheckedIds.has(id)) {
      newCheckedIds.delete(id);
    } else {
      newCheckedIds.add(id);
    }
    setCheckedIds(newCheckedIds);
  };
  const columns = [
  {
      accessor: "id",
      disableFilters: true,
      Cell: ({row}) => {
   const status = row.original.status;
      const shouldDisable = status === "Completed" || status === "Cancelled";
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox 
              checked={checkedIds.has(row.original.id)}
              onChange={() => handleCheckboxChange(row.original.id)}  
                disabled={shouldDisable}
            />
          </Box>
        );
      },
    },
       {
      Header: "Code",
      accessor: "code",
    },
    {
      Header: "Part Name",
      accessor: "partName",
    },
    {
      Header: "From Stock Room Name",
      accessor: "fromStockRoomName",
    },
      {
      Header: "From Aisle Name",
      accessor: "fromAisleName",
    },

      {
      Header: "From Row Name",
      accessor: "fromRowName",
    },
      {
      Header: "From Bin Name",
      accessor: "fromBinName",
    },
    
 
    {
      Header: "To Stock Room Name",
      accessor: "toStockRoomName",
    },
        {
      Header: "To Aisle Name",
      accessor: "toAisleName",
    },
        {
      Header: "To Row Name",
      accessor: "toRowName",
    },
        {
      Header: "To Bin Name",
      accessor: "toBinName",
    },
    {
      Header: "Status",
      accessor: "status",
    },

    {
  Header: "Actions",
  Cell: ({ cell }) => {
    // Check if status is "Created"
    const isCreated = cell.row.original.status === "Created";
    
    return (
      <Box sx={{ whiteSpace: "nowrap" }}>
        <IconButton 
          disabled={!isCreated} // Disable if status is NOT "Created"
          onClick={() => handleEdit(cell.row.original)}
        >
          <EditOutlined
            sx={{
              fontSize: color.masterEditDelButton,
              color: actionsAllow.edit
                ? color.masterEditDelButtonColor
                : "default",
            }}
          />
        </IconButton>

        <Switch
          // disabled={!actionsAllow.delete}
           disabled={!isCreated} 
          checked={cell.row.original.isActive}
          onChange={(e) => handleDelete(e, cell.row.original.id)}
        />
      </Box>
    );
  },
},
  ];
 const statusOptions = [
    { value: "Completed", text: "Mark as Completed" },
    { value: "Cancelled", text: "Mark as Cancelled" }
  ];
  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["partmovement"].title}
        </Typography>
      </Box>

   <TableContainer
        columns={columns}
        data={data}
        buttonNew={handleButtonNew}
        display="visible"
        statusList={statusOptions}
        changeStatusOption={checkedIds.size > 0}
        menuStatusHandle={handleStatusChange}  // Use the status handler here
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
      />

      <Dialog open={create} onClose={handleCreateClose} maxWidth={"md"}>
        <TransferTransactionModal
          handleCloseClick={handleCreateClose}
          mode={mode}
          editData={editData}
          fetchData={getData} 
        />
      </Dialog>
    </>
  );
};

export default TransferTransaction;
